import { CONTACT_INFO } from "../../../config/contactInfo";



// `tone="brand"` is used by the homepage so the footer continues its pale
// green bands; other pages keep the default light background.
const Footer = ({ tone = "light" }) => {
    const currentYear = new Date().getFullYear();
    const toneClass =
        tone === "brand"
            ? "bg-[#f3f9f7] border-t border-[#e3eeea]"
            : "bg-light";
    const headingClass = tone === "brand" ? "text-[#102b23]" : "text-accent";

    return (
        <>
            <footer className={`${toneClass} pt-16 pb-10`}>
                <div className="max-w-7xl mx-auto px-4">

                    {/* ---------- 5 COLUMNS ---------- */}
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-10 text-center md:text-right">

                        {/* ستون 1 – لوگو + توضیح */}
                        <div className="flex flex-col items-center md:items-start">
                            <img src="/images/mizban.png" className="mb-4 w-28" alt="بامیزبان" />
                            <p className="text-default text-sm leading-6">
                                بامیزبان یک پلتفرم هوشمند برای ساخت و مدیریت منوی دیجیتال
                                رستوران‌ها، کافه‌ها و مجموعه‌های غذایی است.
                            </p>
                        </div>

                        {/* ستون 2 – خدمات ما */}
                        <div>
                            <h4 className={`font-bold mb-4 ${headingClass}`}>خدمات ما</h4>
                            <ul className="space-y-2 text-default text-sm">
                                <li>منوی دیجیتال</li>
                                <li>شخصی‌سازی ظاهر</li>
                                <li>مدیریت لحظه‌ای</li>
                                <li>رزرو میز</li>
                                <li>تخفیف‌های مناسبتی</li>
                                <li>آمار و تحلیل فروش</li>
                            </ul>
                        </div>

                        {/* ستون 3 – پشتیبانی */}
                        <div>
                            <h4 className={`font-bold mb-4 ${headingClass}`}>پشتیبانی و راهنما</h4>
                            <ul className="space-y-2 text-default text-sm">
                                <li>سوالات متداول</li>
                                <li>شروع سریع</li>
                                <li>تماس با پشتیبانی</li>
                                <li>همکاری با ما</li>
                            </ul>
                        </div>

                        {/* ستون 4 – تماس با ما */}
                        <div>
                            <h4 className={`font-bold mb-4 ${headingClass}`}>تماس با ما</h4>
                            <ul className="space-y-2 text-default text-sm">
                                <li>
                                    شماره تماس:{" "}
                                    <a href={CONTACT_INFO.phoneHref} dir="ltr" className="hover:text-primary">
                                        {CONTACT_INFO.phoneDisplay}
                                    </a>
                                </li>
                                <li>
                                    ایمیل:{" "}
                                    <a href={`mailto:${CONTACT_INFO.email}`} className="hover:text-primary">
                                        {CONTACT_INFO.email}
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* ستون 5 – آیکن شبکه‌های اجتماعی */}
                        <div className="flex flex-col items-center">   {/* ⬅ ستون را وسط چین کردیم */}
                            <h4 className={`font-bold mb-4 ${headingClass}`}>شبکه‌های اجتماعی</h4>

                            <a
                                href={CONTACT_INFO.instagramUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-2 text-sm text-default hover:text-primary"
                            >
                                <img src="/images/icons/insta.png" className="w-[22px]" alt="اینستاگرام" />
                                <span dir="ltr">@{CONTACT_INFO.instagramHandle}</span>
                            </a>

                            {/* نماد اعتماد الکترونیکی — eNamad validates the seal via the
                                origin referrer, so `noreferrer` must not be added here. */}
                            {/* eslint-disable-next-line react/jsx-no-target-blank */}
                            <a
                                referrerPolicy="origin"
                                target="_blank"
                                href="https://trustseal.enamad.ir/?id=8073774&Code=538YOZDcEsiRflfjnl1GEifKA1tAjsPe"
                                className="mt-6"
                            >
                                <img
                                    referrerPolicy="origin"
                                    src="https://trustseal.enamad.ir/logo.aspx?id=8073774&Code=538YOZDcEsiRflfjnl1GEifKA1tAjsPe"
                                    alt="نماد اعتماد الکترونیکی"
                                    style={{ cursor: "pointer" }}
                                    code="538YOZDcEsiRflfjnl1GEifKA1tAjsPe"
                                />
                            </a>
                        </div>


                    </div>

                    {/* ---------- SEPARATOR LINE ---------- */}
                    <div className="border-t border-[#D9D9D9] w-[90%] mx-auto my-12"></div>

                    {/* ---------- COPYRIGHT ---------- */}
                    <div className="mt-6 text-center text-sm leading-7 text-default">
                        تمام حقوق این پلتفرم متعلق به بامیزبان است.
                        <br />
                        Bamizban © {currentYear} – راهکار هوشمند مدیریت منوی دیجیتال
                    </div>
                </div>
            </footer>
        </>

    );
};

export default Footer;



